class EcTopbarCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[data-carousel-track]');
    this.slides = container.querySelectorAll('.ec-topbar__carousel-slide');
    this.prevButton = container.querySelector('[data-carousel-prev]');
    this.nextButton = container.querySelector('[data-carousel-next]');
    this.currentIndex = 0;
    this.autoPlayInterval = null;
    this.autoPlayDelay = 5000;

    if (!this.track || this.slides.length <= 1) {
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
      return;
    }

    this.init();
  }

  init() {
    this.updateButtons();
    this.setupEventListeners();
    this.startAutoPlay();
  }

  setupEventListeners() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prev());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.next());
    }

    this.container.addEventListener('mouseenter', () => this.stopAutoPlay());
    this.container.addEventListener('mouseleave', () => this.startAutoPlay());
  }

  updateButtons() {
    if (this.prevButton) {
      this.prevButton.disabled = this.currentIndex === 0;
    }

    if (this.nextButton) {
      this.nextButton.disabled = this.currentIndex === this.slides.length - 1;
    }
  }

  goToSlide(index) {
    if (index < 0 || index >= this.slides.length) return;

    this.currentIndex = index;
    const translateX = -index * 100;
    this.track.style.transform = `translateX(${translateX}%)`;
    this.updateButtons();
    this.resetAutoPlay();
  }

  next() {
    if (this.currentIndex < this.slides.length - 1) {
      this.goToSlide(this.currentIndex + 1);
    } else {
      this.goToSlide(0);
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.goToSlide(this.currentIndex - 1);
    } else {
      this.goToSlide(this.slides.length - 1);
    }
  }

  startAutoPlay() {
    this.stopAutoPlay();
    if (this.slides.length > 1) {
      this.autoPlayInterval = setInterval(() => {
        this.next();
      }, this.autoPlayDelay);
    }
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
      this.autoPlayInterval = null;
    }
  }

  resetAutoPlay() {
    this.stopAutoPlay();
    this.startAutoPlay();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('[data-topbar-carousel]');
  carousels.forEach(container => {
    new EcTopbarCarousel(container);
  });
});
